import {Exclude, Expose, Transform, Type} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';
import {RatingApiModel} from './rating.api-model';
import {FollowApiModel} from './follow.api-model';
import {GarageStatusEnum} from '../../features/user/garage/garage-status.enum';
import {ReactionApiModel} from './reaction.api.model';
import {VehicleAttributes} from "../../core/interfaces/vehicle-attributes";
import {EquipmentApiModel} from "./equipment.api-model";
import {VehicleApiModel} from "./vehicle.api-model";
import {UserApiModel} from "./user.api-model";
import {OwnerApiModel} from "../interfaces/owner-api.model";
import {VehicleTypeEnum} from "../../core/enums/vehicle-type.enum";
import {ProjectVehicleParametersOverrideApiModel} from "./project-vehicle-parameters-override.api-model";
import {VehicleParameterViewModel} from "../../features/user/project/parameters/vehicle-parameter-view-model.interface";

@Exclude()
export class ProjectApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public user: UserApiModel|string;
  @Expose() public vehicle: VehicleApiModel|string;
  @Expose() public status: GarageStatusEnum;
  @Transform(({value, obj}) => (value ?? obj?.is_on_sale) ?? false, { toClassOnly: true })
  @Expose() public isOnSale: boolean;
  @Expose() public vehicleType: VehicleTypeEnum;
  @Expose() public sections: string[];
  @Expose() public shortDesc: string;
  @Expose() public alias: string;
  @Expose() public identity: string;
  @Expose() public maskedVin: string | null;
  @Expose() public slug: string;
  @Type(() => Date)
  @Expose() public externalHistoryAllowedAt: Date = null;
  @Expose() public hashtags: string[];
  @Transform(({value}) => value?.map(owner => ({...owner, user: typeof owner.user === 'string' ? owner.user : owner.user?.['@id']})), {toPlainOnly: true})
  @Expose() public owners: OwnerApiModel[];
  @Type(() => RatingApiModel)
  @Expose() public ratings: RatingApiModel[];
  @Expose() public averageRating: number;
  @Expose() public ratingCount: number;
  @Expose() public currentUserRating: number;
  @Expose() public targets: string[];
  @Expose() public theme: string;
  @Expose() public thumbnail: string;
  @Expose() public locked: boolean;
  @Expose() public media: string[];
  @Expose() public instagramProfileUrl: string | null;
  @Expose() public instagramUserProfileUrl: string | null;
  @Expose() public instagramSyncSources: string[] = [];
  @Expose() public instagramLinkedUsername: string | null;
  @Expose() public instagramIntegrationStatus: string | null;
  @Expose() public instagramSyncLimitations: string[] = [];
  @Expose() public instagramProfileMismatch: boolean = false;
  @Expose() public documents: string[];
  @Type(() => FollowApiModel)
  @Expose() public follows: FollowApiModel[];
  @Type(() => ReactionApiModel)
  @Expose() public reactions: ReactionApiModel[];
  @Expose() public likes: string[];
  @Expose() public updatedAt: Date;
  @Expose() public createdAt: Date;
  @Expose() public attributes: VehicleAttributes;
  @Type(() => EquipmentApiModel)
  @Expose() public equipment: EquipmentApiModel[]|string[];
  @Type(() => ProjectVehicleParametersOverrideApiModel)
  @Expose() public vehicleParametersOverride: ProjectVehicleParametersOverrideApiModel | string;
  @Expose() public vehicleParameterViewModels: VehicleParameterViewModel[];
}
